// Import from NPM
// -------------------------------------
import React, { useEffect } from "react";
import { useGetCourseLibraryQuery } from "@api/apiV6";
import { useNavigate } from "react-router-dom";

import { Loader } from "semantic-ui-react";
import _ from "lodash";

// Import from Config
// -------------------------------------

// Import Components
// -------------------------------------

export default function SimReportsHOC(props) {
    const {
        data: library,
        isLoading,
        isSuccess: librarySuccess,
    } = useGetCourseLibraryQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (librarySuccess) {
            if (
                library?.courses &&
                _.keys(_.pickBy(library?.courses, { launch: true })).length ===
                    1
            ) {
                navigate(
                    `/sim/${
                        _.keys(_.pickBy(library?.courses, { launch: true }))[0]
                    }/reports`
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [librarySuccess, library, library?.courses]);

    // ========================= Render Function =================================
    if (isLoading) return <Loader active />;
    return <div />;
}
